module.exports = __webpack_public_path__ + "static/media/kid1.16dfc2b3.png";